import React, { useState, useEffect } from 'react'
import './RelevingEmployees.css'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getDistrictByZoneId, getStates } from '../../../services/monthlyAttendanceService';
import { employeeResignsList, releveEmployee } from '../../../services/resignationService';
import { format } from 'date-fns';
import { capitalizeFirstLetter } from '../../../utils/validations';



const RelevingEmployees = () => {
    const [errors, setErrors] = useState({});
    const empIdUnq = localStorage.getItem("employeeUniqueIdLogin");
    const zoneId = localStorage.getItem("zoneId");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [district, setDistrict] = useState("");
    const [employeesData, setEmployeesData] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [state, setState] = useState(3);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [resignationDate, setResignationDate] = useState(null);
    const [remarks, setRemarks] = useState("");
    const [isFocused, setIsFocused] = useState({
        employeeName: false,
        fromDate: false,
        district: false,
        relevingDistrict: false,
        relevingLocation: false,
        reportingTo: false,
        // role: false,
        toDate: false,
        clients: false,
    });

    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(data.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName),
                })));
            } catch (err) {
                console.error('Error fetching states:', err);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };



        fetchStates();
    }, []);

    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(data.map(item => ({
                        value: item.districtId,
                        label: item.districtName,
                    })));
                } catch (err) {
                    console.error('Error fetching districts:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {

            setDistrictOptions([]);

        }
    }, [state]);



    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption
            ? Array.isArray(selectedOption)
                ? selectedOption.map(opt => opt.value)
                : selectedOption.value
            : null;

        switch (field) {
            case 'state':
                setState(value);
                setDistrict("");
                break;
            case "district":
                setDistrict(value);
                break;

            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleGenerateEmployees = async (e) => {
       if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
    }
        try {
            const data = await employeeResignsList(state,district);
            setEmployeesData(data);
        } catch (error) {
            console.error("Error fetching employee data:", error);
        }
    };

    const handleClear = () => {
        setDistrict('');
        setState('');
        setFromDate(null);
        setToDate(null);
        setEmployeesData([]);

        // Reset focus states so labels return to their original positions
        setIsFocused({
            employeeName: false,
            fromDate: false,
            district: false, // This ensures the label moves down
            relevingDistrict: false,
            relevingLocation: false,
            reportingTo: false,
            toDate: false,
            clients: false,
            state: false // Reset state focus too
        });
    };

    // Open modal handler
    const handleResignClick = (emp) => {
        setSelectedEmployee(emp);
        setIsModalOpen(true);
    };

    // Close modal handler
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedEmployee(null);
        setResignationDate(null);
        setRemarks("");
    };
    const handleSubmitResignation = async () => {
        const payload = {
            releavingById: empIdUnq,
            releavingDate: format(resignationDate, 'yyyy-MM-dd'),
            remarks: remarks
        };
        console.log("Submitting Resignation:", payload);
        const selectedEmp = selectedEmployee.resignationId
        // Call your API service here
        try {
            const data = await releveEmployee(selectedEmp, payload);
            console.log(data);
            await handleGenerateEmployees();
        }
        catch (error) {
            console.log(error);
        }
        closeModal();
    };
    return (
        <div className="employee-releving-maincontainer">
            <div className="employee-releving-box">
                <h2 className="employee-releving-heading">Releaving Employees</h2>
                <div className="employee-releving-structure-heading">
                    <div className="employee-releving-maincontainer-1">

                        <div className="employee-releving-container-part">
                            <div className={`employee-releving-floating-label-container-2 ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span> State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>

                        <div className="employee-releving-container-part">
                            <div className={`employee-releving-floating-label-container-2 ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, "district")}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))} // Add this line
                                    placeholder=" "
                                    isClearable
                                    styles={selectStyles}
                                />
                                <label> District</label>

                            </div>

                        </div>

                    </div>


                    <div className="employee-releving-maincontainer-1">

                        <div className="employee-releving-container-part">
                            {/* <div className={`employee-releving-floating-label-container-2 ${isFocused.toDate || toDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={toDate}
                                    onChange={date => {
                                        setToDate(date);
                                        setErrors(prev => ({ ...prev, toDate: null }));
                                    }}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, toDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, toDate: false }))}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText=" "
                                    className="employee-releving-date-picker"
                                    minDate={fromDate ? new Date(fromDate) : null}
                                />
                                <label><span className="required">*</span>To Date</label>

                            </div> */}
                        </div>
                        <div className="employee-releving-container-part">
                            <div className='btns-flex'>


                                <button onClick={handleClear} className="employee-releving-clear" disabled={!state}>Clear</button>

                                <button type="button" className="employee-releving-btn" onClick={handleGenerateEmployees} disabled={!state}>Fetch</button>
                            </div>
                        </div>
                    </div>


                </div>

            </div>
            <div className='employee-releving-box-table '>
                <table className='table-resign-emp-reg'>
                    <thead>
                        <tr className='resign-emp-det-tr'>
                            <th>S.No</th>
                            <th>Employee Name</th>
                            <th>Employee ID</th>
                            <th>Designation</th>
                            {/* <th>Contact Number</th> */}
                            <th>Client</th>
                            <th>Project</th>
                            <th>Resign Date</th>
                            <th>Notice Period Date</th>
                            <th>Resign Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            employeesData.length > 0 ? (
                                employeesData.map((emp, index) => (
                                    <tr key={emp.id || index} className='resign-emp-det-tr'>
                                        <td>{index + 1}</td>
                                        <td>{emp.employeeName}</td>
                                        <td>{emp.employeeId}</td>
                                        <td>{emp.designation}</td>
                                        {/* <td>{emp.contactNumber}</td> */}
                                        <td>{emp.client}</td>
                                        <td>{emp.project}</td>
                                        <td>{format(emp.lastDate, 'dd-MM-yyyy')}</td>
                                        <td>{format(emp.noticePeriodDate, 'dd-MM-yyyy')}</td>
                                        <td>{emp.status}</td>
                                        <td>
                                            <button
                                                className="employee-releving-btn"
                                                style={{ padding: '5px 15px' }}
                                                onClick={() => handleResignClick(emp)}
                                            >
                                                Update
                                            </button>
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className='header-name-res' >No data available</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            {isModalOpen && (
                <div className="confirm-overlay">
                    <div className="confirm-box" style={{ minWidth: '400px' }}>
                        <h3 className="header-name-res">Resignation Details</h3>
                        <p>Employee: <strong>{selectedEmployee?.employeeName}</strong></p>

                        <div className="employee-releving-floating-label-container-2 float-label" style={{ marginTop: '20px' }}>
                            <DatePicker
                                selected={resignationDate}
                                onChange={(date) => setResignationDate(date)}
                                dateFormat="dd-MM-yyyy"
                                className="custom-datepicker"
                                placeholderText="Select Date"
                            />
                            <label>Resignation Date <span className="required">*</span></label>
                        </div>

                        <div className="employee-releving-floating-label-container-2 float-label" style={{ marginTop: '20px' }}>
                            <textarea
                                // className="custom-datepicker"
                                style={{ height: '80px', textAlign: 'left' }}
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Enter remarks here..."
                            />
                            <label>Remarks </label>
                        </div>

                        <div className="btns-flex" style={{ marginTop: '20px' }}>
                            <button className="employee-releving-clear" onClick={closeModal}>Cancel</button>
                            <button
                                className="employee-releving-btn"
                                onClick={handleSubmitResignation}
                                disabled={!resignationDate}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default RelevingEmployees